import { render, staticRenderFns } from "./minrent-card.vue?vue&type=template&id=8d67f9e0&scoped=true&"
import script from "./minrent-card.vue?vue&type=script&lang=js&"
export * from "./minrent-card.vue?vue&type=script&lang=js&"
import style0 from "./minrent-card.vue?vue&type=style&index=0&id=8d67f9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d67f9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d67f9e0')) {
      api.createRecord('8d67f9e0', component.options)
    } else {
      api.reload('8d67f9e0', component.options)
    }
    module.hot.accept("./minrent-card.vue?vue&type=template&id=8d67f9e0&scoped=true&", function () {
      api.rerender('8d67f9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/minrent-card.vue"
export default component.exports